export const RoutesPath = {
  welcome: '',
  default: {
    home: 'home',
    account: 'account',
    project: 'project',
    event: 'event',
    events: 'events',
    events_ended: 'events/ended',
    project_create: 'project/create',
    project_edit: 'project/edit',
    event_create: 'event/create',
    event_edit: 'event/edit',
    verified: 'projects/verified',
    mcd: 'ecoheroes',
    mcd_verified: 'ecoheroes/verified',
    mcd_ended: 'ecoheroes/ended',
    mcd_in_review: 'ecoheroes/in-review',
    mcd_action: 'mcd-action',
    mcd_action_create: 'mcd-action/create',
    mcd_action_edit: 'mcd-action/edit',
    mcd_dashboard: 'mcd-dashboard',
    help_ukraine_request: 'help-ukraine-request',
    help_ukraine: 'helpukraine',
    help_ukraine_verified: 'helpukraine/verified',
    help_ukraine_ended: 'helpukraine/ended',
    help_ukraine_in_review: 'helpukraine/in-review',
    help_ukraine_create: 'help-ukraine-request/create',
    help_ukraine_faq: 'helpukraine-faq',
    airbnb: 'articles/airbnb',
    how_to_help_ukraine: 'articles/how-to-help-ukraine',
    draft: 'projects/draft',
    in_review: 'projects/in-review',
    ended: 'projects/ended',
    faq: 'faq',
    cart: 'cart',
    profile: 'profile',
    profileTabs: {
      verified: 'verified',
      inReview: 'in-review',
      ended: 'ended',
      donated: 'donated',
      drafts: 'drafts',
      summary: 'summary',
    },
    blog: 'blog',
    articles: 'articles',
    how_it_works: 'articles/how-it-works',
    wallet: 'wallet',
    funds: 'funds',
    kyc: 'kyc',
    reports: 'reports',
    ranking: 'ranking',
    payment_paypal: 'payment-paypal',
    payment_tpay: 'payment-tpay',
    transactionStatus: 'transaction-status',
    terms: 'terms-of-conditions',
    tefal_terms: 'tefal-terms',
    helpukraine_regulations: 'helpukraine-regulations',
    about: 'about',
    abouthelpukraine: 'about-help-ukraine',
    enquiries: 'enquiries',
    privacy: 'privacy-policy',
    our_mission: 'our-mission',
    ubo: 'ubo',
    cisi: 'cisibohaterowie',
    referral: 'r',
    worldwithoutwaste: 'worldwithoutwaste',
    ambassador: 'ambassador',
    wcd: 'wcd',
    earthday: 'earthday',
    worldcleanupday: 'worldcleanupday',
    eventsWcd: 'events-wcd',
    verifiedWcd: 'projects-wcd/verified',
    how_it_works_wcd: 'articles/how-it-works-wcd',
    newLayout: 'new-layout',
    newHomepage: 'new-homepage',
    backbase: 'backbase',
    eventsBackbase: 'eventsBackbase',
    verifiedBackbase: 'projects-backbase/verified',
  },
  auth: {
    login: 'login',
    register: 'register',
    resetPass: 'resetting-password',
    confirmEmail: 'confirm-email',
  },
  profile: {
    verified: 'profile/:id/verified',
  },
  notFound: '**',
};
